import { useEffect, useMemo, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Download } from '@mui/icons-material';
import { CSVLink } from 'react-csv';
import axios from 'axios';

const CSV_HEADERS = [
    { label: 'Rank', key: 'cmc_rank' },
    { label: 'Name', key: 'name' },
    { label: 'Symbol', key: 'symbol' },
    { label: 'Price', key: 'price' },
    { label: 'Qty', key: 'qty' },
    { label: 'Ave Buy', key: 'avg_buy' },
    { label: 'Total Invested', key: 'invested' },
    { label: 'ATH', key: 'ATH' },
    { label: 'ATL', key: 'OG_ATL' },
    { label: 'Market Cap', key: 'market_cap' },
];

const toCsvRow = (item) => ({
    cmc_rank: item?.cmc_rank ?? '',
    name: item?.name ?? '',
    symbol: item?.symbol ?? '',
    price: item?.price ?? '',
    qty: item?.qty ?? '',
    avg_buy: item?.avg_buy ?? '',
    invested: item?.invested ?? '',
    ATH: item?.ATH ?? '',
    OG_ATL: item?.OG_ATL ?? item?.ATL ?? '',
    market_cap: item?.market_cap ?? '',
});

const ExportPortfolioCsv = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        axios.get('/api/v1/crypto/my-coin')
            .then((res) => setData(res.data.data?.[0]?.assets || []))
            .catch(() => setData([]));
    }, []);

    const csvData = useMemo(
        () => (Array.isArray(data) ? data.map(toCsvRow) : []),
        [data]
    );

    const logExport = () => {
        axios.post('/api/v1/user/activity', { type: 'export-to-excel' }).catch(() => {});
    };

    if (!csvData.length) return null;

    return (
        <Tooltip title="Export portfolio to CSV">
            <span style={{ display: 'inline-flex' }}>
                <CSVLink
                    onClick={logExport}
                    data={csvData}
                    headers={CSV_HEADERS}
                    filename={`xgain-crypto-${new Date().toISOString().slice(0, 10)}.csv`}
                    style={{ display: 'inline-flex', color: 'inherit', textDecoration: 'none' }}
                >
                    <IconButton size="small" sx={{ color: '#fff' }} aria-label="Export portfolio to CSV">
                        <Download />
                    </IconButton>
                </CSVLink>
            </span>
        </Tooltip>
    );
};

export default ExportPortfolioCsv;
